'use client';
import { type PropsWithChildren, useState } from 'react';
import { ErrorBoundary, Provider } from '@rollbar/react';
import { getEnv } from '@witmetrics/utils/env';
import { NODE_ENV } from '@witmetrics/utils/constants';
import { useMountEffect } from '@/hooks/useMountEffect';
import { ROLLBAR_ACCESS_TOKEN } from './constants';

export default function RollbarProvider({ children }: PropsWithChildren) {
  const [config, setConfig] = useState<{
    accessToken: string;
    environment: string;
  }>();

  useMountEffect(() => {
    setConfig({
      accessToken: ROLLBAR_ACCESS_TOKEN,
      environment: getEnv(),
    });
  });

  return !config || config.environment === NODE_ENV.DEVELOPMENT ? (
    <>{children}</>
  ) : (
    <Provider config={config}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Provider>
  );
}
